export function getBaseEndpoint () {
  if (INKIVE.C.WHITE_LABEL_CONFIGURATION && INKIVE.C.WHITE_LABEL_CONFIGURATION.domain) {
    return `brand/companies/${INKIVE.C.WHITE_LABEL_CONFIGURATION.domain}`;
  }

  return 'business';
}

export async function fetchGeneratedImageUrl (id) {
  const endpointBase = getBaseEndpoint();
  const { url } = await INKIVE.DesygnerApi.get(`${endpointBase}/background-removal/download/${id}`);

  return url;
}

export async function fetchImageData (image) {
  const endpointBase = getBaseEndpoint();
  const { id, secret } = await INKIVE.DesygnerApi.post(`${endpointBase}/background-removal?edit=true&sync=true`, {
    image,
    edit: true,
    sync: true
  });

  if (!id || !secret) throw new Error('Invalid response from background removal');

  return { id, secret };
}
